var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table-container w-full" }, [
    _c(
      "div",
      { staticClass: "flex overflow-x-auto" },
      _vm._l(_vm.tableCnt, function (i) {
        return _c(
          "table",
          {
            key: i,
            class: [
              "max-w-none border-2 border-gray-600 bg-white table-fixed",
              _vm.tableCnt === 1
                ? "mx-auto"
                : i === 1
                ? "ml-auto"
                : i === _vm.tableCnt
                ? "mr-auto ml-2"
                : "ml-2",
            ],
            staticStyle: { width: "auto" },
          },
          [
            _c("thead", { staticClass: "border border-gray-600 bg-gray-200" }, [
              _c("tr", { staticClass: "border border-gray-600" }, [
                _c("th", [_vm._v(_vm._s(_vm.$t("testBank.sheet.number")))]),
                _c("th", [_vm._v(_vm._s(_vm.$t("testBank.answer")))]),
                _c("th", [_vm._v(_vm._s(_vm.$t("testBank.sheet.point")))]),
              ]),
            ]),
            _c(
              "tbody",
              _vm._l(_vm.questionCntPerTable(i), function (j) {
                return _c(
                  "tr",
                  {
                    key: j,
                    staticClass: "h-8 border border-gray-600 transition",
                    class: [
                      { "cursor-pointer hover:bg-gray-100": !_vm.disabled },
                    ],
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.onMoveQuestion(_vm.questionNum(i, j))
                      },
                    },
                  },
                  [
                    _c("td", [_vm._v(_vm._s(_vm.questionNum(i, j)))]),
                    _c(
                      "td",
                      {
                        class: [
                          _vm.question(i, j)?.questionType === "CHOICE"
                            ? "py-1"
                            : "py-3",
                        ],
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex justify-center items-center gap-x-1 break-all",
                          },
                          _vm._l(
                            _vm.question(i, j)?.answerList,
                            function (answer, k) {
                              return _c(
                                "div",
                                {
                                  key: answer.answerId,
                                  class: {
                                    hidden:
                                      _vm.question(i, j)?.questionType ===
                                        "CHOICE" && !answer.correct,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        _vm.question(i, j)?.questionType ===
                                        "CHOICE"
                                          ? "w-5 h-5 border border-gray-800 rounded-full flex justify-center items-center"
                                          : "max-w-sm text-left whitespace-pre-line",
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.question(i, j)?.questionType ===
                                            "CHOICE"
                                            ? k + 1
                                            : answer.answerText
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                    _c("td", [
                      _vm._v(_vm._s(_vm.question(i, j).questionScore)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }